import { LoaderFunctionArgs } from 'react-router';

import { getImpactCalculateTourForProject } from '@/domain/impact-calculate-tour/actions/get-impact-calculate-tour-for-project.action';
import { runImpactCalculateTourAllForProject } from '@/domain/impact-calculate-tour/actions/run-impact-calculate-tour-all-for-project.action';
import { clearImpactCo2Answers } from '@/domain/impact-co2/actions/clear-impact-co2-answers.action';
import { getImpactCo2Answers } from '@/domain/impact-co2/actions/get-impact-co2-answers.action';
import { getImpactEnvQuestions } from '@/domain/impact-env/actions/get-impact-env-questions.action';
import { getImpactEnvResponses } from '@/domain/impact-env/actions/get-impact-env-responses.action';
import { getImpactEssQuestions } from '@/domain/impact-ess/actions/get-impact-ess-questions.action';
import { getImpactEssResponses } from '@/domain/impact-ess/actions/get-impact-ess-responses.action';
import { projectSlice } from '@/domain/project/project.slice';
import { getProjectTour } from '@/domain/project-tour/actions/get-project-tour.action';
import { getProjectsTour } from '@/domain/project-tour/actions/get-projects-tour.action';
import { clearTourEvents } from '@/domain/project-tour-ontour/actions/clear-tour-events.action';
import { clearTourTravels } from '@/domain/project-tour-ontour/actions/clear-tour-travels.action';
import { getTourEvents } from '@/domain/project-tour-ontour/actions/get-tour-events.action';
import { getTourSequences } from '@/domain/project-tour-ontour/actions/get-tour-sequences.action';
import { getTourTravels } from '@/domain/project-tour-ontour/actions/get-tour-travels.action';
import { setCurrentSequenceId } from '@/domain/project-tour-ontour/actions/set-current-on-tour-sequence.action';
import { store } from '@/domain/store';
import { prepareAuth } from '@/ui/navigation/loaders/prepare-auth-loader';

import { makeCommonGets } from '../appLoaders';

export async function tourIndexLoader() {
  await store.dispatch(projectSlice.actions.changeMode('tour'));
  return null;
}

export async function toursLoader() {
  const { userIsConnected } = await prepareAuth();
  if (!userIsConnected) {
    return null;
  }
  makeCommonGets();
  store.dispatch(getProjectsTour());
  // TODO add various clear.. (see other loaders)
  return null;
}

export async function tourLoader({ params }: LoaderFunctionArgs) {
  const { userIsConnected } = await prepareAuth();
  if (!userIsConnected) {
    return null;
  }
  makeCommonGets();
  const projectId = parseInt(params.id as string);
  await store.dispatch(getProjectTour(projectId));
  store.dispatch(runImpactCalculateTourAllForProject({ projectId }));
  store.dispatch(clearImpactCo2Answers());
  store.dispatch(getImpactCo2Answers({ projectId }));
  store.dispatch(getImpactEnvQuestions());
  store.dispatch(getImpactEnvResponses({ projectId }));
  store.dispatch(getImpactEssQuestions({}));
  store.dispatch(getImpactEssResponses({ projectId }));
  store.dispatch(getTourSequences());
  store.dispatch(clearTourTravels());
  store.dispatch(clearTourEvents());
  store.dispatch(setCurrentSequenceId(null));
  return null;
}

export async function tourOntourLoader({ params }: LoaderFunctionArgs) {
  const { userIsConnected } = await prepareAuth();
  if (!userIsConnected) {
    return null;
  }
  makeCommonGets();

  // tour project
  const projectId = parseInt(params.id as string);
  await store.dispatch(getProjectTour(projectId));
  store.dispatch(getImpactCalculateTourForProject({ projectId }));

  // sequence
  await store.dispatch(getTourSequences());
  const sequenceId = parseInt(params.sequenceId as string);
  await store.dispatch(setCurrentSequenceId(sequenceId));
  store.dispatch(getTourEvents({ sequenceId }));
  store.dispatch(getTourTravels({ sequenceId }));
  store.dispatch(getImpactCo2Answers({ projectId: sequenceId })); // various cost co2 answers

  return null;
}
